import { Component} from '@angular/core';

import { NgxLinkifyjsService } from 'ngx-linkifyjs';

import {NotificationService} from '../shared/notification.service';
import {UserSettingsService} from '../shared/user-settings.service';

@Component({
    selector: 'notifications-component',
    templateUrl: 'notifications.component.html'
})
export class NotificationsComponent {
    constructor(private linkService: NgxLinkifyjsService, private userSettings: UserSettingsService, private notifyService: NotificationService) {}
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/notifications/notifications.component.ts